import classNames from "classnames";
import Link from "next/link";
import { useRef } from "react";
import { useOnClickOutside, useToggle } from "usehooks-ts";
import Icon from "~/assets/icons/Icon";
import IconPath from "~/assets/icons/iconPaths";
import { getSideMenuItems } from "~/components/Backroom/FormUpsertProduct/getSideMenuItems";
import Button from "~/components/Button";
import { StrapiProduct } from "~/shared-types";
import { getRoute } from "~/utils/getRoute";

type Props = {
  product: StrapiProduct;
};

export const EditMenu = ({ product }: Props) => {
  const [showMenu, toggleMenu, setShowMenu] = useToggle(false);
  const steps = getSideMenuItems();
  const menuRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(menuRef, () => setShowMenu(false));

  return (
    <div
      ref={menuRef}
      className="flex items-center justify-end gap-5 mb-10 xl:px-16 2xl:px-40 relative"
    >
      <Button variant="primary-light" size="lg">
        <Link href="/backroom/products" className="flex items-center gap-2.5">
          <Icon name="arrowLeft" className="w-6 h-6" />
          Tilbage
        </Link>
      </Button>
      <Button
        variant="primary-light"
        size="lg"
        onClick={toggleMenu}
        className="flex items-center gap-2.5"
      >
        Rediger
        <Icon name="chevronDown" className="w-6 h-6" />
      </Button>
      {showMenu ? (
        <ul
          className={classNames(
            "absolute z-10 top-14 bg-white text-secondary-600 p-4 pb-1 rounded-lg shadow-sm"
          )}
        >
          {steps.map((step) => (
            <Link
              key={step.id}
              href={getRoute(
                `/backroom/products/:id/edit`,
                { id: product.id },
                { query: { step: step.id } }
              )}
              className="flex items-center gap-2.5 mb-2 p-2 hover:bg-secondary-100 hover:text-secondary-900 rounded-lg"
            >
              <Icon
                name={step.payload.icon as keyof typeof IconPath}
                className="min-w-6 w-6 h-6"
              />
              {step.payload.sideMenuTitle}
            </Link>
          ))}
        </ul>
      ) : null}
    </div>
  );
};
